var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shouldShowParent
    ? _c(
        "li",
        {
          ref: "sidebarRef",
          staticClass: "parent-nav-item",
          class: { aside_active: _vm.isActive() || _vm.activeLink },
        },
        [
          _vm.link && _vm.link.type === "search"
            ? _c("div", { staticClass: "item-parent-nav-item" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleSearchPopup()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-search" }),
                    _vm._v(" "),
                    _c("h6", { staticClass: "title fs-12 custom-h" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.Lang.get(`messages.sidebar.${_vm.link.label}`)
                          ) +
                          "\n      "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "child-nav-item",
                    class: { show: _vm.showSearchPopup },
                  },
                  [
                    _c("h4", { staticClass: "modal_title custom-h" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.Lang.get(`messages.sidebar.${_vm.link.label}`)
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "accordion custom-ul child_list",
                        attrs: { id: `accordionExample${_vm.link.label}` },
                      },
                      [
                        _c("li", { staticClass: "position-relative" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchQuery,
                                expression: "searchQuery",
                              },
                            ],
                            staticClass: "w-100",
                            attrs: {
                              type: "search",
                              id: "searchInput",
                              placeholder: "",
                            },
                            domProps: { value: _vm.searchQuery },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.searchQuery = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "search-icon position-absolute",
                            attrs: {
                              src: "/assets/front_end/assets/images/search.svg",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.filteredSearchResults.length
                          ? _c(
                              "ul",
                              { staticClass: "custom-ul mt-2" },
                              _vm._l(
                                _vm.filteredSearchResults,
                                function (item, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: item.label + index,
                                      staticClass:
                                        "dropdown-item d-flex justify-content-between align-items-center",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-grow-1",
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addToLinkHistory(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "h6",
                                            { staticClass: "third-color m-0" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.Lang.get(
                                                      `messages.sidebar.${item.label}`
                                                    )
                                                  ) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.id
                                        ? _c("img", {
                                            staticStyle: {
                                              filter: "grayscale(1)",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              src: "/assets/front_end/assets/images/close-circle.svg",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeSearchResult(
                                                  index,
                                                  item
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c("ul", { staticClass: "custom-ul mt-2" }, [
                              _c("li", { staticClass: "dropdown-item" }, [
                                _c("h6", { staticClass: "third-color m-0" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.Lang.get(
                                          "messages.sidebar.no_search_results"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                              ]),
                            ]),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm.link && _vm.link.type === "group"
            ? _c("div", { staticClass: "item-parent-nav-item" }, [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.toggleDropdown(_vm.link)
                      },
                    },
                  },
                  [
                    _c("i", { class: [_vm.link.icon, "fs-24"] }),
                    _vm._v(" "),
                    _c("h6", { staticClass: "title fs-12 custom-h" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.Lang.get(`messages.sidebar.${_vm.link.label}`)
                          ) +
                          "\n      "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "child-nav-item modal-container",
                    class: { show: _vm.currentOpenGroup === _vm.link.label },
                  },
                  [
                    _c("h4", { staticClass: "modal_title custom-h" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.Lang.get(`messages.sidebar.${_vm.link.label}`)
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "accordion custom-ul child_list",
                        attrs: {
                          id: `accordionExample${_vm.slugify(_vm.link.label)}`,
                        },
                      },
                      _vm._l(_vm.link.children, function (child, index) {
                        return _vm.hasVisibleChildren(child.children)
                          ? _c(
                              "li",
                              { key: child.label + index, staticClass: "card" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header",
                                    attrs: {
                                      id: `heading-${_vm.slugify(
                                        child.label
                                      )}-${index}`,
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-link w-100",
                                        attrs: {
                                          "data-toggle": "collapse",
                                          "data-target": `#collapse-${_vm.slugify(
                                            child.label
                                          )}-${index}`,
                                          "aria-controls": `collapse-${_vm.slugify(
                                            child.label
                                          )}-${index}`,
                                          "aria-expanded": "true",
                                        },
                                      },
                                      [
                                        _c(
                                          "h6",
                                          {
                                            staticClass:
                                              "child-title fw-500 fs-16 custom-h",
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.Lang.get(
                                                    `messages.sidebar.${child.label}`
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse show",
                                    attrs: {
                                      id: `collapse-${_vm.slugify(
                                        child.label
                                      )}-${index}`,
                                      "aria-labelledby": `heading-${_vm.slugify(
                                        child.label
                                      )}-${index}`,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "card-body" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "sub_category_list custom-ul",
                                        },
                                        _vm._l(
                                          child.children,
                                          function (sub_child) {
                                            return sub_child.children &&
                                              sub_child.children.length > 0 &&
                                              (sub_child.permission
                                                ? _vm.canAny(
                                                    sub_child.permission
                                                  )
                                                : true)
                                              ? _c(
                                                  "li",
                                                  {
                                                    key:
                                                      sub_child.label + index,
                                                    staticClass: "card",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "card-header",
                                                        attrs: {
                                                          id: `heading-${_vm.slugify(
                                                            sub_child.label
                                                          )}`,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-link w-100",
                                                            attrs: {
                                                              "data-toggle":
                                                                "collapse",
                                                              "data-target": `#collapse-${_vm.slugify(
                                                                sub_child.label
                                                              )}`,
                                                              "aria-expanded":
                                                                "false",
                                                              "aria-controls": `collapse-${_vm.slugify(
                                                                sub_child.label
                                                              )}`,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "h6",
                                                              {
                                                                staticClass:
                                                                  "child-title fw-500 fs-16 custom-h",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.Lang.get(
                                                                        `messages.sidebar.${sub_child.label}`
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "collapse show",
                                                        attrs: {
                                                          id: `collapse-${_vm.slugify(
                                                            sub_child.label
                                                          )}`,
                                                          "aria-labelledby": `heading-${_vm.slugify(
                                                            sub_child.label
                                                          )}`,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "card-body",
                                                          },
                                                          [
                                                            _c(
                                                              "ul",
                                                              {
                                                                staticClass:
                                                                  "sub_category_list custom-ul",
                                                              },
                                                              _vm._l(
                                                                sub_child.children,
                                                                function (
                                                                  innerChild
                                                                ) {
                                                                  return (
                                                                    innerChild.permission
                                                                      ? _vm.canAny(
                                                                          innerChild.permission
                                                                        )
                                                                      : true
                                                                  )
                                                                    ? _c(
                                                                        "li",
                                                                        {
                                                                          key:
                                                                            innerChild.label +
                                                                            index,
                                                                          staticClass:
                                                                            "d-flex align-items-center justify-content-between",
                                                                          class:
                                                                            {
                                                                              aside_active:
                                                                                _vm.isLinkActive(
                                                                                  innerChild
                                                                                ),
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "router-link",
                                                                            {
                                                                              staticClass:
                                                                                "fw-500 custom-h child-item-title",
                                                                              attrs:
                                                                                {
                                                                                  to: {
                                                                                    path: innerChild.path,
                                                                                    query:
                                                                                      innerChild.query,
                                                                                  },
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                            " +
                                                                                  _vm._s(
                                                                                    _vm.Lang.get(
                                                                                      `messages.sidebar.${innerChild.label}`
                                                                                    )
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _vm.checkItemInFav(
                                                                            innerChild.path
                                                                          )
                                                                            ? _c(
                                                                                "svg",
                                                                                {
                                                                                  staticClass:
                                                                                    "fav_icon",
                                                                                  attrs:
                                                                                    {
                                                                                      xmlns:
                                                                                        "http://www.w3.org/2000/svg",
                                                                                      width:
                                                                                        "22",
                                                                                      height:
                                                                                        "23",
                                                                                      viewBox:
                                                                                        "0 0 22 23",
                                                                                      fill: "none",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.removeFromFav(
                                                                                          _vm.checkItemInFav(
                                                                                            innerChild.path
                                                                                          )
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "path",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          d: "M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z",
                                                                                          fill: "#1BC6D1",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "path",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          d: "M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z",
                                                                                          fill: "#1BC6D1",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "svg",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      xmlns:
                                                                                        "http://www.w3.org/2000/svg",
                                                                                      width:
                                                                                        "22",
                                                                                      height:
                                                                                        "23",
                                                                                      viewBox:
                                                                                        "0 0 22 23",
                                                                                      fill: "none",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.addToFav(
                                                                                          innerChild
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "path",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          d: "M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z",
                                                                                          fill: "#5d5d5d",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "path",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          d: "M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z",
                                                                                          fill: "#5d5d5d",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e()
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : (
                                                  sub_child.permission
                                                    ? _vm.canAny(
                                                        sub_child.permission
                                                      )
                                                    : true
                                                )
                                              ? _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center justify-content-between",
                                                    class: {
                                                      aside_active:
                                                        _vm.isLinkActive(
                                                          sub_child
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "fw-500 custom-h child-item-title",
                                                        attrs: {
                                                          to: {
                                                            path: sub_child.path,
                                                            query:
                                                              sub_child.query,
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.Lang.get(
                                                                `messages.sidebar.${sub_child.label}`
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.checkItemInFav(
                                                      sub_child.path
                                                    )
                                                      ? _c(
                                                          "svg",
                                                          {
                                                            staticClass:
                                                              "fav_icon",
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "22",
                                                              height: "23",
                                                              viewBox:
                                                                "0 0 22 23",
                                                              fill: "none",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.removeFromFav(
                                                                  _vm.checkItemInFav(
                                                                    sub_child.path
                                                                  )
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z",
                                                                fill: "#1BC6D1",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z",
                                                                fill: "#1BC6D1",
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _c(
                                                          "svg",
                                                          {
                                                            attrs: {
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                              width: "22",
                                                              height: "23",
                                                              viewBox:
                                                                "0 0 22 23",
                                                              fill: "none",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.addToFav(
                                                                  sub_child
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M16.6477 2.35962L16.2956 3.74617C18.7979 5.41978 20.448 8.27143 20.448 11.5004C20.448 16.57 16.3805 20.7098 11.3352 20.8199L10.2619 22.1478C10.5463 22.1713 10.8342 22.183 11.1258 22.183C17.0169 22.183 21.8093 17.3896 21.8093 11.4995C21.8093 7.6278 19.7412 4.23182 16.6495 2.35871L16.6477 2.35962ZM1.80178 11.5004C1.80178 6.42901 5.87298 2.29011 10.9164 2.17908L11.987 0.8521C11.7026 0.82863 11.4147 0.816895 11.1249 0.816895C5.23477 0.816895 0.441406 5.60845 0.441406 11.5004C0.441406 15.3721 2.51221 18.7681 5.60307 20.6412L5.95422 19.2528C3.45192 17.5792 1.80178 14.7294 1.80178 11.5004Z",
                                                                fill: "#5d5d5d",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M17.8081 9.86836C17.6925 9.62644 17.4632 9.48201 17.196 9.48201H13.3397L15.5269 0.850347C15.5811 0.636406 15.5432 0.436909 15.4159 0.274422C15.2823 0.102908 15.0729 0 14.8553 0C14.654 0 14.4753 0.088465 14.3399 0.256368L4.52657 12.4113C4.35776 12.6198 4.32617 12.8888 4.44171 13.1307C4.55545 13.3691 4.79106 13.5171 5.05465 13.5171H8.9101L6.72285 22.1497C6.66868 22.3636 6.7066 22.5631 6.83388 22.7265C6.96658 22.898 7.176 23 7.39355 23C7.59486 23 7.77359 22.9115 7.9099 22.7427L17.7232 10.5878C17.8893 10.3829 17.9218 10.1067 17.8072 9.86836H17.8081Z",
                                                                fill: "#5d5d5d",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : (_vm.link.permission ? _vm.canAny(_vm.link.permission) : true)
            ? _c(
                "div",
                { staticClass: "item-parent-nav-item 2" },
                [
                  _c("i", { class: [_vm.link.icon, "fs-24"] }),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "title fs-12 custom-h stretched-link",
                      attrs: {
                        to: { path: _vm.link.path, query: _vm.link.query },
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.Lang.get(`messages.sidebar.${_vm.link.label}`)
                          )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }